(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.sr = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      autocomplete: {
        noDataMessage: 'Нису пронађени подаци'
      },
      combobox: {
        placeholder: 'Изаберите',
        searchPlaceholder: 'Претрага'
      },
      datepicker: {
        apply: 'Примени',
        clearSelection: 'Обриши',
        pickADays: 'Изаберите дане',
        prevYear: 'Претходне године',
        nextYear: 'Следеће године',
        prevMonth: 'Претходног месеца',
        nextMonth: 'Следећег месеца',
        year: '',
        month1: 'јануар',
        month2: 'фебруар',
        month3: 'март',
        month4: 'април',
        month5: 'мај',
        month6: 'јун',
        month7: 'јул',
        month8: 'август',
        month9: 'септембар',
        month10: 'октобар',
        month11: 'новембар',
        month12: 'децембар',
        weeks: {
          sun: 'Нед.',
          mon: 'Пон.',
          tue: 'Уто.',
          wed: 'Сре.',
          thu: 'Чет.',
          fri: 'Пет.',
          sat: 'Суб.'
        },
        months: {
          jan: 'јан.',
          feb: 'феб.',
          mar: 'мар.',
          apr: 'апр.',
          may: 'мај',
          jun: 'јун',
          jul: 'јул',
          aug: 'авг.',
          sep: 'сеп.',
          oct: 'окт.',
          nov: 'нов.',
          dec: 'дец.'
        },
        pickADay: 'Изаберите дан'
      },
      timepicker: {
        meridiemAM: 'Пре подне',
        meridiemPM: 'По подне'
      },
      dropdown: {
        noDataMessage: 'Нису пронађени подаци'
      },
      filepicker: {
        browse: 'Потражи',
        select: 'Изаберите датотеку'
      },
      filter: {
        apply: 'Примени',
        cancel: 'Откажи',
        filterButton: 'Филтер',
        reset: 'Поништи филтере',
        resetDefault: 'Успостави подразумеване вредности'
      },
      search: {
        noDataMessage: 'Нису пронађени подаци'
      },
      'multi-search': {
        'separator-and': 'И',
        'search-button': 'Претрага',
        'search-placeholder': 'Претражи по имену'
      },
      select: {
        all: 'Све',
        clearSelection: 'Обриши избор',
        noMatch: 'Нису пронађени подаци',
        noData: 'Нема података',
        placeholder: 'Изаберите',
        item: 'ставка/е',
        selected: 'изабрано',
        found: 'пронађено'
      },
      upload: {
        browseButton: 'Потражи',
        text: 'Превуците и отпустите датотеке за отпремање или кликните на дугме „Потражи“',
        tip: 'Можете да отпремите 10 датотека чија је величина до 25 MB'
      },
      table: {
        emptyText: 'Нема података'
      },
      tree: {
        emptyText: 'Нема података'
      }
    }
  };
  _exports.default = _default;
});